<div class="content-layout">
  <mat-drawer-container>
    <mat-drawer [mode]="drawerMode" [opened]="opened$ | async" (closed)="drawerClosed()" [position]="'end'" #matDrawer>
      <router-outlet name="task"></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <div class="header">
        <div class="header__left">
          <a backButton mat-icon-button><mat-icon [svgIcon]="'arrow_back'"></mat-icon></a>
          <p class="contact-title">{{ contact?.name }}</p>
        </div>

        <div class="header__right">
          <button [appAuthorize]="hasAnyPermission()" class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
            <mat-icon [svgIcon]="'more_vert'"></mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            <button
              [appAuthorize]="Permission.CONTACTS_MERGE"
              class="cancel-button"
              mat-menu-item
              (click)="openMergeDialog()"
            >
              <mat-icon svgIcon="call_merge"></mat-icon>
              Merge
            </button>
            <button [appAuthorize]="canDelete()" mat-menu-item (click)="deleteContact()">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="flex">
        <!-- First column -->
        <div class="flex flex-col w-1/4 bg-white border-r-2 border-solid">
          <!-- Contact Info -->
          <treo-card class="flex flex-col w-full overflow-auto rounded-none">
            <div class="flex flex-col flex-auto full-height">
              <form [formGroup]="contactForm" class="contact-form mx-3" [ngClass]="{ 'edit-mode': editMode }">
                <div class="text-right mt-3" *ngIf="editMode">
                  <!-- Cancel button -->
                  <button
                    class="cancel-button"
                    mat-icon-button
                    *ngIf="editMode"
                    [matTooltip]="'Cancel'"
                    (click)="toggleEditMode(false)"
                  >
                    <mat-icon [svgIcon]="'cancel'"></mat-icon>
                  </button>

                  <!-- Save button -->
                  <button
                    mat-icon-button
                    *ngIf="editMode"
                    [disabled]="contactForm?.invalid"
                    [matTooltip]="'Save'"
                    (click)="updateContact()"
                  >
                    <mat-icon [svgIcon]="'save'"></mat-icon>
                  </button>
                </div>

                <!-- Avatar and Name -->
                <div class="avatar-and-name py-3">
                  <div class="avatar">
                    <div class="avatar-edit-container" *ngIf="editMode && !isUploadingAvatarImage">
                      <div class="upload">
                        <input
                          id="avatar-file-input"
                          type="file"
                          [multiple]="false"
                          [accept]="'image/jpeg, image/png'"
                          (change)="uploadAvatar(avatarFileInput.files)"
                          #avatarFileInput
                        />
                        <label for="avatar-file-input" matRipple>
                          <mat-icon [svgIcon]="'photo_camera'" matTooltip="Upload avatar"></mat-icon>
                        </label>
                      </div>

                      <div class="remove" *ngIf="contact.avatar_url">
                        <button mat-icon-button (click)="removeAvatar()" matTooltip="Remove avatar">
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                        </button>
                      </div>
                    </div>

                    <mat-spinner *ngIf="isUploadingAvatarImage" diameter="50"></mat-spinner>

                    <img *ngIf="contact.avatar_url && !isUploadingAvatarImage" [src]="contact.avatar_url" #avatar />

                    <div class="no-avatar" *ngIf="!contact.avatar_url && !isUploadingAvatarImage">
                      {{ contact.name?.charAt(0) }}
                    </div>
                  </div>

                  <!-- View -->
                  <div class="view" *ngIf="contact.name && !editMode">
                    <!-- Name -->
                    <div class="name">{{ contact.name }}</div>
                    <!-- Tags -->
                    <div class="tags">
                      <ng-container *ngIf="contact.tag_list?.length && !editMode">
                        <div class="tag" *ngFor="let tag of contact.tag_list | keyvalue">
                          <span class="tag-title">{{ tag.value }}</span>
                        </div>
                      </ng-container>
                    </div>

                    <!-- Send Email & Add Note buttons -->
                    <div class="user-action-buttons flex flex-row items-center mt-2">
                      <span [matTooltip]="contact.email ? '' : 'Please Add Email address to contact'">
                        <button
                          class="xs:hidden email-button"
                          [disabled]="!contact.email"
                          (click)="openContactSendMessageModal()"
                        >
                          <mat-icon class="icon-size-18" [svgIcon]="'email'"></mat-icon>
                        </button>
                      </span>
                      <button
                        [appAuthorize]="NewPermission.CONTACTS_EDIT"
                        denyAction="disable"
                        class="ml-2 xs:hidden note-button"
                        (click)="openContactAddNoteModal()"
                      >
                        <mat-icon class="icon-size-18" [svgIcon]="'note'"></mat-icon>
                      </button>
                      <button
                        [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
                        denyAction="disable"
                        class="ml-2 xs:hidden call-button"
                        (click)="addContactEngagementModal('Call')"
                      >
                        <mat-icon class="icon-size-18" [svgIcon]="'phone'"></mat-icon>
                      </button>
                      <button
                        [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
                        denyAction="disable"
                        class="ml-2 xs:hidden engagement-button"
                        (click)="addContactEngagementModal('Meeting')"
                      >
                        <mat-icon class="icon-size-18" [svgIcon]="'calendar_today'"></mat-icon>
                      </button>
                    </div>
                  </div>

                  <!-- Edit -->
                  <div class="edit ml-1" *ngIf="editMode">
                    <mat-form-field class="name edit treo-mat-no-subscript">
                      <input matInput [formControlName]="'name'" [placeholder]="'Name'" [spellcheck]="false" />
                    </mat-form-field>

                    <mat-form-field class="example-chip-list mt-3 w-full">
                      <mat-chip-list #chipList aria-label="Tag selection">
                        <mat-chip
                          *ngFor="let tag of contact.tag_list | keyvalue"
                          [selectable]="true"
                          [removable]="true"
                          (removed)="removeTag(tag.value)"
                        >
                          {{ tag.value }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                          class="my-2"
                          placeholder="New tag..."
                          #tagInput
                          [formControl]="tagCtrl"
                          [matAutocomplete]="auto"
                          [matChipInputFor]="chipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="addTag($event)"
                          (focus)="tagInput.focused = true"
                          (blur)="tagInput.focused = false"
                        />
                      </mat-chip-list>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTag($event)">
                        <mat-option *ngFor="let tag of foundTags | keyvalue" [value]="tag.key">
                          {{ tag.key }}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-hint *ngIf="tagInput.focused" class="mt-2">
                        Press <strong>TAB</strong> key after finishing typing to add a new tag
                      </mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="actions">
                    <!-- Edit button -->
                    <button
                      [appAuthorize]="NewPermission.CONTACTS_EDIT"
                      class="edit-button"
                      mat-icon-button
                      *ngIf="!editMode"
                      (click)="toggleEditMode(true)"
                    >
                      <mat-icon [svgIcon]="'edit'"></mat-icon>
                    </button>
                  </div>
                </div>

                <!-- Contact Category -->
                <div class="category" *ngIf="contact.category_name || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'work'"></mat-icon>
                  <div class="view" *ngIf="contact.category_name && !editMode">
                    <div class="name">
                      {{ contact.category_name }}
                    </div>
                  </div>
                  <!-- Contact Category Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Contact Type</mat-label>
                      <mat-select [formControlName]="'category_id'">
                        <mat-option *ngFor="let category of categories" [value]="category.id">
                          {{ category.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Job -->
                <div class="job" *ngIf="contact.job_title || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'business'"></mat-icon>
                  <div class="view" *ngIf="!editMode">
                    <div class="title" *ngIf="contact.job_title">
                      {{ contact.job_title }}
                    </div>
                  </div>
                  <!-- Contact Job Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Job Title</mat-label>
                      <input matInput [formControlName]="'job_title'" [placeholder]="'Title'" />
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Related Company -->
                <div class="company" *ngIf="contact.company_name || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'business'"></mat-icon>
                  <div class="view" *ngIf="!editMode">
                    <div class="company font-medium leading-none" *ngIf="contact.company_name">
                      <a [routerLink]="['../../companies/' + contact?.company?.id]">{{ contact.company_name }}</a>
                    </div>
                  </div>
                  <!-- Contact Related Company Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Company</mat-label>
                      <input
                        matInput
                        [formControlName]="'company_name'"
                        [placeholder]="'Company Name'"
                        [matAutocomplete]="matAutocompleteCompany"
                        [spellcheck]="false"
                      />
                    </mat-form-field>
                    <mat-autocomplete
                      #matAutocompleteCompany="matAutocomplete"
                      [disableRipple]="true"
                      (optionSelected)="autocompleteCompanySelected($event)"
                    >
                      <mat-option class="no-results" *ngIf="companyResults && !companyResults.length">
                        No companies found!
                      </mat-option>

                      <mat-option *ngFor="let companyResult of companyResults" [value]="companyResult">
                        {{ companyResult }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>

                <!-- Contact Email -->
                <div class="emails" *ngIf="contact.email || editMode">
                  <span *ngIf="contact.email && !editMode" (click)="openContactSendMessageModal()">
                    <mat-icon class="icon icon-size-18" [svgIcon]="'email'"></mat-icon>
                  </span>
                  <span *ngIf="editMode">
                    <mat-icon class="icon icon-size-18" [svgIcon]="'email'"></mat-icon>
                  </span>
                  <div class="view" *ngIf="contact.email && !editMode" (click)="openContactSendMessageModal()">
                    <div class="name">{{ contact.email }}</div>
                  </div>
                  <!-- Contact Email Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Email</mat-label>
                      <input matInput [formControlName]="'email'" [placeholder]="'Email'" [spellcheck]="false" />
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Phone number -->
                <div class="phone-number" *ngIf="contact.phone || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'phone'"></mat-icon>
                  <div class="view" *ngIf="contact.phone && !editMode">
                    <div class="name">
                      {{ contact.phone | mask: FieldMaskUtils.getPhoneNumberMask(contact.phone) }}
                    </div>
                  </div>
                  <!-- Contact Phone number Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Phone Number</mat-label>
                      <input
                        matInput
                        [mask]="FieldMaskUtils.getPhoneNumberMask(contactForm.get('phone').value)"
                        [formControlName]="'phone'"
                        [placeholder]="'Phone Number'"
                        [spellcheck]="false"
                        [value]="contactForm.get('phone').value | phone"
                        digitOnly
                      />
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact External URL -->
                <div class="remote-url" *ngIf="contact.remote_url || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'link'"></mat-icon>
                  <div class="view" *ngIf="contact.remote_url && !editMode">
                    <div class="name"><span [innerHTML]="contact.remote_url | linkify"></span></div>
                  </div>
                  <!-- Contact External URL Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>External URL</mat-label>
                      <input
                        matInput
                        [formControlName]="'remote_url'"
                        [placeholder]="'External Url'"
                        [spellcheck]="false"
                        [value]="contactForm.get('remote_url').value"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Mobile Phone number -->
                <div class="mobile-phone-number" *ngIf="contact.mobile_phone || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'phone_iphone'"></mat-icon>
                  <div class="view" *ngIf="contact.mobile_phone && !editMode">
                    <div class="name">
                      {{ contact.mobile_phone | mask: FieldMaskUtils.getPhoneNumberMask(contact.mobile_phone) }}
                    </div>
                  </div>
                  <!-- Contact Mobile Phone number Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Mobile Phone Number</mat-label>
                      <input
                        matInput
                        [mask]="FieldMaskUtils.getPhoneNumberMask(contactForm.get('mobile_phone').value)"
                        [formControlName]="'mobile_phone'"
                        [placeholder]="'Mobile Phone Number'"
                        [spellcheck]="false"
                        [value]="contactForm.get('mobile_phone').value | phone"
                        digitOnly
                      />
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Address -->
                <div class="address" *ngIf="contact.address || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'room'"></mat-icon>
                  <!-- View -->
                  <ng-container *ngIf="!editMode">
                    <div class="view">
                      <p class="title">{{ contact.address.address_string }}</p>
                    </div>
                  </ng-container>
                  <!-- Edit -->
                  <ng-container *ngIf="editMode">
                    <div class="edit">
                      <fieldset class="w-full" [formGroupName]="'address'">
                        <mat-form-field class="w-full">
                          <mat-label>Address</mat-label>
                          <input
                            matInput
                            google-place
                            [placeholder]="'Address'"
                            [formControlName]="'address_string'"
                            (onSelect)="setAddress($event)"
                            (blur)="onAddressBlur()"
                            autocomplete="none"
                          />
                        </mat-form-field>
                      </fieldset>
                    </div>
                  </ng-container>
                </div>

                <!-- Contact User Association -->
                <div class="user-association" *ngIf="contact.associated_with_user || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'person'"></mat-icon>
                  <div class="view" *ngIf="contact.associated_with_user && !editMode">
                    <div class="name">
                      {{ contact.associated_with_user?.full_name }}
                    </div>
                  </div>
                  <!-- Contact User Association Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="w-full">
                      <mat-label>Contact Holder</mat-label>
                      <mat-select [formControlName]="'associated_with_user_id'">
                        <mat-option *ngFor="let user of users" [value]="user.id" [disabled]="!user?.active">
                          {{ user.full_name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Contact Notes -->
                <div class="notes" *ngIf="contact.description || editMode">
                  <mat-icon class="icon icon-size-18" [svgIcon]="'notes'"></mat-icon>
                  <div class="view" *ngIf="!editMode">
                    <div [innerHTML]="contact.description"></div>
                  </div>
                  <!-- Contact Notes Edit -->
                  <div class="edit" *ngIf="editMode">
                    <mat-form-field class="treo-mat-textarea w-full">
                      <mat-label>Contact Notes</mat-label>
                      <textarea
                        matInput
                        treoAutogrow
                        [rows]="5"
                        [formControlName]="'description'"
                        [placeholder]="'Notes'"
                        [spellcheck]="false"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </treo-card>
        </div>

        <!-- Second Column -->
        <div
          class="flex flex-col"
          [ngClass]="{
            'w-2/4': mainTabGroup.selectedIndex < staticTabCount,
            'w-3/4': mainTabGroup.selectedIndex >= staticTabCount,
          }"
        >
          <div class="flex flex-col w-full full-height rounded-none">
            <mat-tab-group
              animationDuration="0ms"
              mat-align-tabs="start"
              (selectedIndexChange)="selectedIndexChange($event)"
              #mainTabGroup
            >
              <!-- Overview -->
              <mat-tab *ngFor="let contactTab of contact?.template?.definition?.tabs">
                <ng-template mat-tab-label>Overview</ng-template>
                <ng-template matTabContent>
                  <div class="mt-3">
                    <div class="flex flex-col w-full overflow-auto custom-field-tab-panel">
                      <div class="w-full">
                        <app-panel-host
                          class="w-full"
                          #panels
                          *ngIf="contactTab"
                          [panelDef]="contactTab.layout[0].panel"
                          [readonly]="!(NewPermission.CONTACTS_EDIT | hasPermission)"
                          [fieldDefs]="allContactsFieldDefs"
                          [canEditLayout]="canEditLayout()"
                          [model]="contact"
                          [data]="data"
                          (panelDefUpdated)="onCustomObjectPanelDefUpdated($event, contactTab)"
                          (dataUpdated)="onCustomObjectPanelDataUpdated($event)"
                          (editToggled)="onCustomObjectPanelEditToggled($event, contactTab)"
                        ></app-panel-host>
                      </div>
                      <div
                        class="w-full custom-field-tab-panel__empty"
                        *ngIf="!(contactTab.layout[0].panel.meta.fields | tsMutateToAny: hasFieldsFn)"
                      >
                        <div class="flex flex-col items-center justify-center h-full">
                          <h4 class="text-gray-500 text-lg mb-4">No fields selected</h4>
                          <p>Select at least one field <a (click)="enableEditModeCustomObjectPanel()">here</a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>

              <!-- Activities -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <span [matBadge]="activities?.length > 0 ? activities.length : null" matBadgeOverlap="false"
                    >Activities
                  </span>
                </ng-template>
                <ng-template matTabContent>
                  <shared-activity [activities]="activities" [relatedTo]="'Contact'"></shared-activity>
                </ng-template>
              </mat-tab>

              <!-- Notes -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <ng-container *ngIf="notes?.length > 0; else NotesDefaultTitle">
                    <span [matBadge]="notes.length" matBadgeOverlap="false">Notes</span>
                  </ng-container>
                  <ng-template #NotesDefaultTitle>
                    <span>Notes</span>
                  </ng-template>
                </ng-template>
                <ng-template matTabContent>
                  <div class="flex items-center justify-end py-2">
                    <ts-button
                      [appAuthorize]="NewPermission.CONTACTS_EDIT"
                      denyAction="disable"
                      icon="add"
                      variant="primary"
                      (click)="openContactAddNoteModal()"
                    >
                      <span>Add Note</span>
                    </ts-button>
                  </div>
                  <ng-container>
                    <div class="flex flex-col w-full">
                      <div class="note-list">
                        <ng-container *ngFor="let note of notes; let i = index; trackBy: trackByFn">
                          <treo-card class="note">
                            <section class="note-content">
                              <!-- Note Header -->
                              <article class="note-content__header">
                                <!-- Note Title -->
                                <ng-container *ngIf="note.title">
                                  <p>
                                    <strong>{{ note.title }}</strong>
                                  </p>
                                </ng-container>

                                <!-- Date -->
                                <div class="date">
                                  {{ note.created_at | date: 'LLL dd, y' }}
                                </div>

                                <!-- Three-dot menu -->
                                <div>
                                  <button
                                    class="more-menu"
                                    mat-icon-button
                                    [matMenuTriggerFor]="moreMenu"
                                    [matTooltip]="'More options'"
                                  >
                                    <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                                  </button>
                                  <mat-menu #moreMenu="matMenu">
                                    <button mat-menu-item (click)="editNote(note)">
                                      <mat-icon class="edit-icon" [svgIcon]="'edit'"></mat-icon>
                                      <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="deleteNote(note)">
                                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                                      <span>Delete</span>
                                    </button>
                                  </mat-menu>
                                </div>
                              </article>

                              <mat-divider class="my-2 w-full"></mat-divider>

                              <!-- Associated contacts -->
                              <ng-container *ngIf="note.contacts?.length">
                                <article class="note-content__associated-contacts">
                                  <mat-icon
                                    class="mr-3"
                                    [svgIcon]="'people'"
                                    [matTooltip]="'Contacts associated with this note'"
                                  ></mat-icon>
                                  <mat-chip-list aria-label="user selection">
                                    <mat-chip *ngFor="let contact of note.contacts">{{ contact.name }}</mat-chip>
                                  </mat-chip-list>
                                </article>
                              </ng-container>

                              <!-- Note body editor -->
                              <article class="note-content__note-body w-full">
                                <quill-view-html
                                  [content]="mentionsService.formatMessage(note.body)"
                                  theme="snow"
                                  sanitize
                                ></quill-view-html>
                              </article>

                              <!-- Note Author -->
                              <ng-container *ngIf="note.user_name">
                                <article class="note-content__note-author mt-2">
                                  <p>
                                    Created by <strong>{{ note.user_name }}</strong>
                                  </p>
                                </article>
                              </ng-container>

                              <!-- Note Type -->
                              <ng-container *ngIf="note.noteable_type && note.noteable_name">
                                <article class="note-content__noteable-related mt-1">
                                  <p class="flex items-center">
                                    {{ note.noteable_type === 'Project' ? 'Deal' : note.noteable_type }} note from
                                    <a class="link flex items-center" (click)="startNavigationTo(note)">
                                      <strong class="ml-1">{{ note.noteable_name }}</strong>
                                      <mat-icon [color]="'primary'" class="ml-1 icon-size-18">exit_to_app</mat-icon>
                                    </a>
                                  </p>
                                </article>
                              </ng-container>
                            </section>
                          </treo-card>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </mat-tab>

              <!-- Engagements -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <ng-container *ngIf="engagements?.length > 0; else NotesDefaultTitle">
                    <span [matBadge]="engagements.length" matBadgeOverlap="false">Engagements</span>
                  </ng-container>
                  <ng-template #NotesDefaultTitle>
                    <span>Engagements</span>
                  </ng-template>
                </ng-template>
                <ng-template matTabContent>
                  <div class="flex items-center justify-end mt-2 gap-1">
                    <ts-button
                      [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
                      denyAction="disable"
                      icon="add"
                      variant="primary"
                      (click)="addContactEngagementModal('Call')"
                      class="mr-1"
                    >
                      <span>Log Call</span>
                    </ts-button>
                    <ts-button
                      [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
                      denyAction="disable"
                      icon="add"
                      variant="primary"
                      (click)="addContactEngagementModal('Meeting')"
                      class="mr-1"
                    >
                      <span>Log Meeting</span>
                    </ts-button>
                    <ts-button
                      [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
                      denyAction="disable"
                      icon="add"
                      variant="primary"
                      (click)="addContactEngagementModal('Social Media')"
                    >
                      <span>Log Social Media</span>
                    </ts-button>
                  </div>
                  <ng-container>
                    <div class="flex flex-col w-full">
                      <div class="note-list">
                        <engagements-crm-panel
                          [engagements]="engagements"
                          (onRefetchEngagements)="fetchEngagements()"
                          (onEditEngagement)="editContactEngagementModal($event)"
                        ></engagements-crm-panel>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </mat-tab>

              <!-- Tasks -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <ng-container *ngIf="tasks?.length; else TasksDefaultTitle">
                    <span [matBadge]="tasks.length" matBadgeOverlap="false">Tasks</span>
                  </ng-container>
                  <ng-template #TasksDefaultTitle>
                    <span>Tasks</span>
                  </ng-template>
                </ng-template>
                <ng-template matTabContent>
                  <div class="flex items-center justify-end mt-2 gap-2">
                    <ts-button variant="secondary" icon="ts_file-save" (click)="openTaskExportDialog()">
                      Export
                    </ts-button>
                    <ts-button
                      variant="primary"
                      icon="add"
                      [appAuthorize]="NewPermission.AGGREGATED_TASK_LISTS_CREATE"
                      denyAction="disable"
                      (click)="createContactTask()"
                      >Add Task</ts-button
                    >
                  </div>
                  <ng-container>
                    <div class="flex flex-col w-full">
                      <div class="note-list">
                        <tasks-crm-panel [tasks]="tasks" (openTaskDetails)="openTaskDetails($event)"></tasks-crm-panel>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </mat-tab>

              <!-- Email Tab -->
              <ng-container *ngIf="!hasEmailAccess()">
                <mat-tab>
                  <ng-template mat-tab-label>
                    <ng-container *ngIf="contact?.emails; else EmailsDefaultTitle">
                      <span [matBadge]="contact.emails.length" matBadgeOverlap="false">Emails</span>
                    </ng-container>
                    <ng-template #EmailsDefaultTitle>
                      <span>Emails</span>
                    </ng-template>
                  </ng-template>
                  <ng-template matTabContent>
                    <div class="flex flex-col w-full my-2">
                      <mailbox-mail-list
                        [relatedToId]="contact.id"
                        [relatedToType]="'Contact'"
                        [account]="account"
                        view="deal"
                      ></mailbox-mail-list>
                    </div>
                  </ng-template>
                </mat-tab>
              </ng-container>

              <!-- Custom Fields Tabs -->
              <mat-tab
                *ngFor="let customObject of customObjects"
                [label]="customObject.label_plural || customObject.label"
              >
              </mat-tab>
            </mat-tab-group>

            <router-outlet *ngIf="mainTabGroup.selectedIndex >= staticTabCount"></router-outlet>
          </div>
        </div>

        <!-- Third Column -->
        <div
          [ngClass]="{
            'flex flex-col w-1/4 bg-white border-l-2 border-solid': mainTabGroup.selectedIndex < staticTabCount,
            'display-none': mainTabGroup.selectedIndex >= staticTabCount,
          }"
        >
          <mat-accordion multi>
            <!-- Deals Panel -->
            @if (canViewDeals()) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="bg-slate-100">
                  <mat-panel-title (click)="$event.stopPropagation()" class="justify-between">
                    <span>
                      <strong>Deals&nbsp;</strong>
                      <ts-badge [value]="pagination?.length || dataSource.data?.length || 0" [type]="'info'"></ts-badge>
                    </span>
                    <ts-button
                      [appAuthorize]="[Permission.DEALS_ADD, NewPermission.CONTACTS_EDIT]"
                      denyAction="disable"
                      [matTooltip]="'Add Deal'"
                      type="icon"
                      icon="ts_plus"
                      iconColor="black"
                      (click)="addDeal()"
                    ></ts-button>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="dataSource.data?.length; else NoRelatedDeals">
                  <ng-container *ngIf="!isPaginationLoading; else LoadingBar">
                    <mat-divider></mat-divider>
                    <mat-table [dataSource]="dataSource" class="p-4 pt-0">
                      <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                        <mat-cell *matCellDef="let project">
                          <div class="font-medium leading-none truncate">
                            <a
                              [matTooltip]="project.title"
                              [routerLink]="[
                                '/projects/' + project.pipeline_id + '/' + project.id + '/details/overview',
                              ]"
                            >
                              <span>{{ project.title }}</span>
                            </a>
                          </div>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                        <mat-cell *matCellDef="let project">
                          <div class="text-md truncate leading-none">
                            <span [matTooltip]="project.property_type?.name">{{ project.property_type?.name }}</span>
                          </div>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="location">
                        <mat-header-cell *matHeaderCellDef>Location</mat-header-cell>
                        <mat-cell *matCellDef="let project">
                          <div class="text-md leading-none text-secondary truncate">
                            <span [matTooltip]="project.city + ', ' + project.state"
                              >{{ project.city }}{{ project.state }}</span
                            >
                          </div>
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: tableColumns" class="py-2"></mat-row>
                    </mat-table>
                    <mat-paginator
                      #dealsPaginator
                      [length]="pagination.length"
                      [pageIndex]="pagination.page"
                      [pageSize]="pagination.size"
                      [pageSizeOptions]="[10, 25, 50, 100]"
                      [showFirstLastButtons]="true"
                      (page)="onPageChange($event, 'Project')"
                    ></mat-paginator>
                  </ng-container>
                </ng-container>
              </mat-expansion-panel>
            }
            <!-- Properties Panel -->
            @if (NewPermission.PROPERTIES_VIEW | hasPermission) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="bg-slate-100">
                  <mat-panel-title (click)="$event.stopPropagation()" class="justify-between">
                    <span>
                      <strong>Properties&nbsp;</strong>
                      <ts-badge
                        [value]="propertiesPagination?.length || propertiesDataSource.data?.length || 0"
                        [type]="'info'"
                      ></ts-badge>
                    </span>
                    <ts-button
                      [appAuthorize]="NewPermission.CONTACTS_EDIT"
                      denyAction="disable"
                      [matTooltip]="'Add Property'"
                      type="icon"
                      icon="ts_plus"
                      iconColor="black"
                      (click)="addProperty()"
                    ></ts-button>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="propertiesDataSource.data?.length; else NoRelatedProperties">
                  <ng-container *ngIf="!propertiesIsPaginationLoading; else LoadingBar">
                    <mat-divider></mat-divider>
                    <mat-table [dataSource]="propertiesDataSource" class="p-4 pt-0">
                      <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                        <mat-cell *matCellDef="let property">
                          <div class="font-medium leading-none truncate">
                            <a [matTooltip]="property.name" [routerLink]="['/properties/' + property.id]">
                              <span>{{ property.name }}</span>
                            </a>
                          </div>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
                        <mat-cell *matCellDef="let property">
                          <div class="text-md truncate leading-none">
                            {{ property.address_string }}
                          </div>
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="propertiesTableColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: propertiesTableColumns" class="py-2"></mat-row>
                    </mat-table>
                    <mat-paginator
                      #propertiesPaginator
                      [length]="propertiesPagination.length"
                      [pageIndex]="propertiesPagination.page"
                      [pageSize]="propertiesPagination.size"
                      [pageSizeOptions]="[10, 25, 50, 100]"
                      [showFirstLastButtons]="true"
                      (page)="onPageChange($event, 'Property')"
                    ></mat-paginator>
                  </ng-container>
                </ng-container>
              </mat-expansion-panel>
            }
            <!-- Loan Quotes Panel -->
            @if (hasLoanQuotesEnabled$ | async) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="bg-slate-100">
                  <mat-panel-title>
                    <strong>Loan Quotes&nbsp;</strong>
                    <ts-badge [value]="loanQuotes?.length || 0" [type]="'info'"></ts-badge>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="loanQuotes?.length; else NoRelatedQuotes">
                  <div class="flex flex-col w-full">
                    <div class="item mb-3" *ngFor="let loanQuote of loanQuotes">
                      <div class="item-content" *ngIf="loanQuote?.project">
                        <div class="info flex flex-row">
                          <task-status [task]="loanQuote" [taskStatuses]="loanWorkflowStates"></task-status>
                          <div class="name w-32 truncate">
                            <a
                              [routerLink]="[
                                '/projects/' +
                                  loanQuote.project.pipeline_id +
                                  '/' +
                                  loanQuote.project.id +
                                  '/loans/' +
                                  loanQuote.loan_request_id,
                              ]"
                              >{{ loanQuote.project.title }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<ng-template #LoadingBar>
  <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
</ng-template>

<ng-template #NoRelatedDeals>
  <section
    class="flex flex-col items-center justify-center h-full py-8"
    *ngIf="!relatedPanelsAreLoading; relatedPanelLoading"
  >
    <mat-icon class="text-hint">check_circle_outline</mat-icon>
    <p class="text-center text-hint">No related deals</p>
  </section>
</ng-template>

<ng-template #NoRelatedProperties>
  <section
    class="flex flex-col items-center justify-center h-full py-8"
    *ngIf="!relatedPanelsAreLoading; relatedPanelLoading"
  >
    <mat-icon class="text-hint">check_circle_outline</mat-icon>
    <p class="text-center text-hint">No related properties</p>
  </section>
</ng-template>

<ng-template #NoRelatedQuotes>
  <section
    class="flex flex-col items-center justify-center h-full py-8"
    *ngIf="!relatedPanelsAreLoading; relatedPanelLoading"
  >
    <mat-icon class="text-hint">check_circle_outline</mat-icon>
    <p class="text-center text-hint">No related loan quotes</p>
  </section>
</ng-template>

<ng-template #RelatedPanelLoading>
  <section class="flex flex-col items-center justify-center h-full opacity-50 py-12">
    <mat-spinner [diameter]="30" color="accent" [strokeWidth]="2"></mat-spinner>
  </section>
</ng-template>
